module.exports = __webpack_public_path__ + "static/img/startLogo1.9c861789.png";